module.exports = __webpack_public_path__ + "static/media/page-loader-hd.23470c99.gif";